import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import DashboardWrapper from '../../components/Dashboard/Wrapper/DashboardWrapper';
import { Layout } from 'antd';
import VetsmithNavigationDrawer from '../../components/VetsmithNavigationDrawer/VetsmithNavigationDrawer';
import LayoutContainer from './VetsmithLayout';
import { GB_FLAGS, JobsPages, isJobPageFeatureEnabled, withLDFlagsFromBackend } from '../../legacy_components/services/launchDarkly';
import jobsActions from '../../legacy_components/UI_V2_Components/jobs/jobs.actions';
import Vetsmith from '../../legacy_components/UI_V2_Components/Vetsmith/Vetsmith';

function VetsmithContainer(props) {
  const { 
    path, 
    new_jobs_dashboard,
    dispatch,
    jobsV2 = []
  } = props;

  const showNavBar = new_jobs_dashboard && jobsV2.length > 0;

  useEffect(() => {
    if (new_jobs_dashboard) {
      dispatch(jobsActions.FETCH_JOBS_V2)
    }
  }, [new_jobs_dashboard])

  const localAuthenticated = localStorage.getItem('authenticated');

  if (!localAuthenticated)
    return <Redirect to="/login" />;

  return (
    <div key="/test">
      <DashboardWrapper>
        <Layout className="mainLayout">
          {showNavBar && <VetsmithNavigationDrawer />}
          <LayoutContainer
            path={path}
            className="mainLayout"
            showNavBar={showNavBar}
          >
            <div className="content-layout">
              <Vetsmith {...props.vetsmithProps} showNavBar={showNavBar} />
            </div>
          </LayoutContainer>
        </Layout>
      </DashboardWrapper>
    </div>
  );
}

VetsmithContainer.propTypes = {
  classes: PropTypes.object.isRequired,
  authenticated: PropTypes.bool.isRequired,
  authenticate: PropTypes.func.isRequired,
  match: PropTypes.object
};

const mapStateToProps = (state) => {
  return { ...state.jobs };
};

const withJobsPageData = (Component) => {
  return (props) => {
    const { LDFlags = {} } = props;
    const { job_dashboard_v2 = {} } = LDFlags;
    const flags = {
      old_recommended_jobs_page: isJobPageFeatureEnabled(job_dashboard_v2, JobsPages.old_recommended_jobs_page),
      new_jobs_dashboard: isJobPageFeatureEnabled(job_dashboard_v2, JobsPages.new_jobs_dashboard),
      new_job_applicatons_tab: isJobPageFeatureEnabled(job_dashboard_v2, JobsPages.new_job_applicatons_tab),
    }
    return <Component {...props} {...flags} />;
  };
}


export default withRouter(
  connect(mapStateToProps, null)
  (withLDFlagsFromBackend(withJobsPageData(VetsmithContainer), [GB_FLAGS.job_dashboard_v2])
));
